import React, { useEffect, useState } from 'react';
import 'styles/connectionStatus.css'; // Importer le style
import Modal from './Modal/Modal';

const useNetworkStatus = () => {
  // const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isOnline, setIsOnline] = useState(true);
  const [effectiveConnectionType, setEffectiveConnectionType] = useState<
    string | null
  >(null);

  useEffect(() => {
    const updateOnlineStatus = () => {
      // setIsOnline(navigator.onLine);
      setIsOnline(true);
    };

    const updateConnectionStatus = () => {
      const connection =
        (navigator as any).connection ||
        (navigator as any).mozConnection ||
        (navigator as any).webkitConnection;
      if (connection) {
        setEffectiveConnectionType(connection.effectiveType);
      }
    };

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    if ('connection' in navigator) {
      const connection = (navigator as any).connection;
      connection.addEventListener('change', updateConnectionStatus);
      updateConnectionStatus();
    }

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
      if ('connection' in navigator) {
        const connection = (navigator as any).connection;
        connection.removeEventListener('change', updateConnectionStatus);
      }
    };
  }, []);

  return { isOnline, effectiveConnectionType };
};

const ConnectionStatus: React.FC = () => {
  const { isOnline, effectiveConnectionType } = useNetworkStatus();

  // Définir un état pour contrôler l'affichage du modal
  const [shouldShowPopup, setShouldShowPopup] = useState<boolean>(false);

  // Gérer la fermeture du modal
  const handleCancel = () => {
    setShouldShowPopup(false);
  };

  // Met à jour le modal en fonction de l'état de la connexion
  useEffect(() => {
    const isConnectionUnstable =
      !isOnline ||
      (effectiveConnectionType &&
        ['2g', 'slow-2g'].includes(effectiveConnectionType))
        ? true
        : false;
    setShouldShowPopup(isConnectionUnstable);
  }, [isOnline, effectiveConnectionType]);

  return (
    <>
      {/* Utiliser shouldShowPopup directement comme condition booléenne */}
      <Modal
        isOpen={shouldShowPopup}
        onClose={handleCancel}
        title='Problème de Connexion'
        showHeader={true}
        showCloseButton={isOnline}
      >
        {isOnline
          ? `Votre connexion est instable. Type de connexion : ${effectiveConnectionType}`
          : 'Vous êtes hors ligne. Vérifiez votre connexion Internet.'}
      </Modal>
    </>
  );
};

export { ConnectionStatus, useNetworkStatus };
